import type { ImageProps } from 'react-native'
import { DISPLAY_NAME, useProductCardContext } from '../..'
import type { ProductCardProps, ProductCardScopedProps } from '../../types'
import { OnSaleTag } from '../on-sale-tag'
import { SponsoredTag } from '../sponsored-tag'
import * as S from './image.styles'

export interface InternalProductCardImageProps
  extends Omit<ImageProps, 'style'> {
  withSponsoredTag?: boolean
  onSale?: string
}

const Image = (props: InternalProductCardImageProps) => {
  const { __scopeProductCard } =
    props as ProductCardScopedProps<ProductCardProps>

  const { withSponsoredTag, onSale } = useProductCardContext(
    DISPLAY_NAME,
    __scopeProductCard
  )

  return (
    <S.ImgContainer>
      <S.Img {...props} resizeMode={props.resizeMode || 'contain'} />
      {withSponsoredTag && <SponsoredTag>Patrocinado</SponsoredTag>}
      {onSale && <OnSaleTag>{onSale}</OnSaleTag>}
    </S.ImgContainer>
  )
}

export { Image }
